import { render, staticRenderFns } from "./CmgLoyaltyRewardsModal.vue?vue&type=template&id=ae7b3654&scoped=true&lang=pug"
import script from "./cmg-loyalty-rewards-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loyalty-rewards-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoyaltyRewardsModal.vue?vue&type=style&index=0&id=ae7b3654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7b3654",
  null
  
)

export default component.exports